module.exports = __webpack_public_path__ + "static/intro-video-thumbnail-720b157f38082c9028779a8f5d9f6011.jpg";